import { EMAIL_PATTERN, MOBILE_PATTERN } from '@origin-digital/validation/dist/es/patterns';

const isAllDigits = (username: string) => /^[0-9]*$/.test(username);

const getMobileErrorMessage = (username: string) =>
  isAllDigits(username)
    ? 'Oops, that number doesn’t look right. Please double check your mobile number or try your email address instead.'
    : 'Oops, that email doesn’t look right. Please double check your email address or try your mobile number instead.';

const getUsernameError = (username: string = ''): string => {
  if (!username) {
    return 'Please enter an email address or mobile number';
  }

  if (MOBILE_PATTERN.test(username) || EMAIL_PATTERN.test(username)) {
    return '';
  }

  return getMobileErrorMessage(username);
};

export { getUsernameError, isAllDigits };
